import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/root.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./config/userProvider";
import { SocketProvider } from "./config/socketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <SocketProvider>
        <App />
      </SocketProvider>
    </UserProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
